<template>
  <div class="start-story-container">
    <div class="zhanwei4"></div>

    <!-- 顶部状态栏与模式分段器 -->
    <div class="story-top-panel">
      <div class="panel-left">
        <h2 class="section-title">游戏剧情叙事编排</h2>
        <span class="section-tip"
          >编排玩家初入游戏的开篇序言与通关后的终局交代</span
        >
      </div>

      <!-- 开场 / 结局 切换控制器 -->
      <div class="panel-right">
        <el-segmented
          v-model="storyTab"
          :options="tabOptions"
          size="large"
          class="custom-story-segmented"
        />
      </div>
    </div>

    <div class="editor-layout">
      <!-- 左侧：表单编辑区 -->
      <div class="form-area">
        <el-form
          :model="form"
          label-width="auto"
          label-position="top"
          ref="ruleForm"
          status-icon
          class="custom-form"
        >
          <!-- ================= 开场序言表单 ================= -->
          <template v-if="storyTab === 'start'">
            <el-form-item label="开场序言标题">
              <el-input
                v-model="form.startTitle"
                placeholder="例如：序章 · 迷雾初起"
                maxlength="40"
                show-word-limit
                clearable
              />
            </el-form-item>

            <el-form-item label="序言背景故事正文">
              <el-input
                v-model="form.startContent"
                type="textarea"
                :rows="9"
                placeholder="请输入引人入胜的开篇故事、背景交代与启程引导..."
                maxlength="1000"
                show-word-limit
              />
            </el-form-item>

            <el-form-item label="开场全屏/封面配图">
              <div class="single-uploader-card">
                <el-upload
                  class="uploader-box"
                  :action="UpdateApi"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :disabled="allowUpload"
                >
                  <div v-if="form.startImg" class="img-preview-box">
                    <el-image
                      :src="form.startImg"
                      class="img-content"
                      fit="contain"
                    />
                    <div class="hover-mask">
                      <span
                        class="del-btn"
                        @click.stop="clearImage(1)"
                        title="删除并重新上传"
                      >
                        <el-icon><Delete /></el-icon>
                      </span>
                    </div>
                  </div>
                  <div v-else class="upload-trigger">
                    <el-icon class="icon"><Plus /></el-icon>
                    <span class="text">点击上传开场插图</span>
                    <span class="sub-text"
                      >支持 4:3 | 1:1 | 3:4 / 小于 5MB</span
                    >
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </template>

          <!-- ================= 游戏结局表单 ================= -->
          <template v-else-if="storyTab === 'end'">
            <el-form-item label="通关结局标题">
              <el-input
                v-model="form.endTitle"
                placeholder="例如：终章 · 真相大白"
                maxlength="40"
                show-word-limit
                clearable
              />
            </el-form-item>

            <el-form-item label="通关结局交代正文">
              <el-input
                v-model="form.endContent"
                type="textarea"
                :rows="9"
                placeholder="请输入揭开全部谜底后的剧情尾声、结局反转或致谢寄语..."
                maxlength="1000"
                show-word-limit
              />
            </el-form-item>

            <el-form-item label="复盘暗号">
              <el-input
                v-model="form.reviewCode"
                placeholder=""
                maxlength="40"
                show-word-limit
                clearable
              />
            </el-form-item>

            <el-form-item label="结局展示配图">
              <div class="single-uploader-card">
                <el-upload
                  class="uploader-box"
                  :action="UpdateApi"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccessEnd"
                  :before-upload="beforeAvatarUpload"
                  :disabled="allowUploadEnd"
                >
                  <div v-if="form.endImg" class="img-preview-box">
                    <el-image
                      :src="form.endImg"
                      class="img-content"
                      fit="contain"
                    />
                    <div class="hover-mask">
                      <span
                        class="del-btn"
                        @click.stop="clearImage(2)"
                        title="删除并重新上传"
                      >
                        <el-icon><Delete /></el-icon>
                      </span>
                    </div>
                  </div>
                  <div v-else class="upload-trigger">
                    <el-icon class="icon"><Plus /></el-icon>
                    <span class="text">点击上传结局插图</span>
                    <span class="sub-text"
                      >支持 4:3 | 1:1 | 3:4 / 小于 5MB</span
                    >
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </template>
        </el-form>

        <div class="action-bar">
          <el-button
            type="primary"
            class="save-btn"
            size="large"
            :loading="saving"
            @click="handleSave"
          >
            保存全部剧情（开场与结局）
          </el-button>
        </div>
      </div>

      <!-- 右侧：现代手机拟物化真机视口（随 Tab 联动） -->
      <div class="preview-area">
        <div class="preview-header">
          <span class="badge-dot"></span>
          <span
            >移动端{{
              storyTab === "start" ? "启程序章" : "通关终局"
            }}呈现</span
          >
        </div>

        <div class="mockup-phone">
          <div class="phone-top-bar">
            <div class="notch"></div>
          </div>

          <div class="phone-screen">
            <!-- 顶部导航 -->
            <div class="mock-nav">
              <span class="nav-title">{{
                storyTab === "start" ? "启程序章" : "终局揭晓"
              }}</span>
            </div>

            <!-- 顶部配图视口 -->
            <div class="screen-hero">
              <template v-if="storyTab === 'start'">
                <el-image
                  v-if="form.startImg"
                  :src="form.startImg"
                  alt="序言配图"
                  fit="contain"
                  class="hero-img"
                />
                <div v-else class="hero-placeholder">
                  <el-icon><PictureFilled /></el-icon>
                  <span>暂无开场插图</span>
                </div>
              </template>
              <template v-else>
                <el-image
                  v-if="form.endImg"
                  :src="form.endImg"
                  alt="结局配图"
                  class="hero-img"
                  fit="contain"
                />
                <div v-else class="hero-placeholder">
                  <el-icon><PictureFilled /></el-icon>
                  <span>暂无结局插图</span>
                </div>
              </template>
            </div>

            <!-- 正文内容区 -->
            <div class="screen-body">
              <template v-if="storyTab === 'start'">
                <h3 class="screen-title">
                  {{ form.startTitle || "序言标题占位" }}
                </h3>
                <div class="screen-desc">
                  {{
                    form.startContent ||
                    "开篇剧情、背景设定或启程引言将在此处完整展示，支持自动断行与上下平滑滑动..."
                  }}
                </div>
              </template>
              <template v-else>
                <h3 class="screen-title">
                  {{ form.endTitle || "结局标题占位" }}
                </h3>
                <div class="screen-desc">
                  {{
                    form.endContent ||
                    "通关解谜交代、真相真相复盘或最终谢幕致辞将在此处完整展示..."
                  }}
                </div>
              </template>
            </div>

            <!-- 底部操作按钮 -->
            <div class="screen-footer">
              <button class="mock-next-btn">
                {{
                  storyTab === "start"
                    ? "开启冒险旅途"
                    : "完成探索 · 查看积分结算"
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="zhanwei4"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Plus, Delete, PictureFilled } from "@element-plus/icons-vue";
import { ElMessage, ElNotification } from "element-plus";

export default defineComponent({
  name: "StoryStartModule",
  components: { Plus, Delete, PictureFilled },
  props: ["dataForm"],
  data(): any {
    return {
      storyTab: "start", // 'start' | 'end'
      tabOptions: [
        { label: "开场序章", value: "start" },
        { label: "游戏结局", value: "end" },
      ],
      saving: false,
      form: {
        id: null,
        gameId: null,
        startTitle: "",
        startContent: "",
        startImg: "",
        endTitle: "",
        reviewCode: "",
        endContent: "",
        endImg: "",
        mediaType: "image",
        videoLink: null,
        createTime: null,
      },
      fileList: [],
    };
  },
  computed: {
    story(): number {
      return this.$store.state.game.story;
    },
    allowUpload(): boolean {
      return Boolean(this.form.startImg);
    },
    allowUploadEnd(): boolean {
      return Boolean(this.form.endImg);
    },
    UpdateApi(): string {
      return process.env.VUE_APP_Update_API || "";
    },
  },
  mounted() {
    const routeGameId = this.$route.params.id;
    const storeStory = this.$store.state.game.story;

    if (
      !storeStory ||
      Object.keys(storeStory).length === 0 ||
      storeStory.gameId != routeGameId
    ) {
      this.$store
        .dispatch("game/getStory", { gameId: routeGameId })
        .then((res: any) => {
          if (res) {
            this.form = {
              ...this.form,
              ...res,
              startTitle: res.startTitle || "",
              startContent: res.startContent || "",
              startImg: res.startImg || "",
              endTitle: res.endTitle || "",
              endContent: res.endContent || "",
              endImg: res.endImg || "",
              reviewCode: res.reviewCode || "",
            };
          }
        })
        .catch(() => {});
    } else {
      this.form = {
        ...this.form,
        ...storeStory,
        startTitle: storeStory.startTitle || "",
        startContent: storeStory.startContent || "",
        startImg: storeStory.startImg || "",
        endTitle: storeStory.endTitle || "",
        endContent: storeStory.endContent || "",
        reviewCode: storeStory.reviewCode || "",
        endImg: storeStory.endImg || "",
      };
    }
  },
  methods: {
    handleSave() {
      this.saving = true;
      const storyPayload = {
        id: this.form.id,
        gameId: this.$route.params.id,
        startTitle: this.form.startTitle || "",
        startContent: this.form.startContent || "",
        startImg: this.form.startImg || "",
        endTitle: this.form.endTitle || "",
        endContent: this.form.endContent || "",
        endImg: this.form.endImg || "",
        reviewCode: this.form.reviewCode || "",
        mediaType: "image",
        videoLink: null,
      };

      this.$store
        .dispatch("game/updateGameStart", storyPayload)
        .then((res: any) => {
          if (res) {
            this.form = { ...this.form, ...res };
          }
          ElMessage.success("开场与结局剧情已成功保存");
        })
        .catch(() => {
          ElMessage.error("保存失败，请稍后重试");
        })
        .finally(() => {
          this.saving = false;
        });
    },
    beforeAvatarUpload(file: File): boolean {
      const isAllowed =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/webp";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isAllowed) {
        ElNotification.warning({
          message: "请上传 PNG/JPG/WEBP 格式图片",
          offset: 100,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片体积不可超过 2MB",
          offset: 100,
        });
        return false;
      }
      return true;
    },
    handleAvatarSuccess(response: any) {
      if (response?.data?.returnFileUrl) {
        this.form.startImg = response.data.returnFileUrl;
      }
    },
    async clearImage(status: number) {
      const fileName = status == 1 ? this.form.startImg : this.form.endImg;

      if (!fileName) return;

      try {
        // 1. 匹配 action 参数签名（传对象）
        const delFinished = await this.$store.dispatch("user/delFile", {
          fileName,
        });

        // 2. 只有删除成功后才清空前端字段
        if (delFinished === 1) {
          if (status == 1) {
            this.form.startImg = "";
          } else {
            this.form.endImg = "";
          }
        }
      } catch (error) {
        console.error("清除图片失败:", error);
      }
    },
    handleAvatarSuccessEnd(response: any) {
      if (response?.data?.returnFileUrl) {
        this.form.endImg = response.data.returnFileUrl;
      }
    },
  },
});
</script>

<style lang="less" scoped>
@primary-color: #5d5fef;
@primary-hover: #4b4de0;
@primary-light: #f0f2ff;
@text-main: #1e293b;
@text-sub: #64748b;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@danger-color: #ef4444;

.zhanwei4 {
  height: 20px;
}

.start-story-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

// 顶部说明与分段器
.story-top-panel {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid @border-color;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .panel-left {
    display: flex;
    align-items: baseline;
    gap: 12px;

    .section-title {
      font-size: 17px;
      font-weight: 700;
      color: @text-main;
      margin: 0;
    }

    .section-tip {
      font-size: 13px;
      color: @text-muted;
    }
  }

  .custom-story-segmented {
    padding: 3px;
    background-color: #f1f5f9;
    border-radius: 8px;

    :deep(.el-segmented__item) {
      font-weight: 600;
      font-size: 13px;
      padding: 6px 18px;
      border-radius: 6px;
      transition: all 0.2s;

      &.is-selected {
        color: #fff;
        background: #ffffff;
        box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08);
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

// 双栏编辑布局
.editor-layout {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  background: #ffffff;
  padding: 32px;
  border-radius: 16px;
  border: 1px solid @card-border;
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;

  @media (max-width: 992px) {
    flex-direction: column;
    align-items: center;
  }
}

// 左侧表单排版
.form-area {
  flex: 1;
  max-width: 600px;
  width: 100%;

  .custom-form {
    :deep(.el-form-item) {
      margin-bottom: 22px;

      .el-form-item__label {
        font-size: 13.5px;
        font-weight: 600;
        color: @text-main;
        padding-bottom: 6px;
      }
    }

    :deep(.el-input__wrapper),
    :deep(.el-textarea__inner) {
      border-radius: 8px;
      box-shadow: 0 0 0 1px @border-color inset;
      transition: all 0.2s ease;

      &:hover {
        box-shadow: 0 0 0 1px #cbd5e1 inset;
      }

      &.is-focus,
      &:focus {
        box-shadow: 0 0 0 1px @primary-color inset !important;
      }
    }
  }

  // 单图卡片上传器
  .single-uploader-card {
    .uploader-box {
      :deep(.el-upload) {
        width: 100%;
        display: block;
        cursor: pointer;
      }
    }

    .img-preview-box {
      position: relative;
      width: 100%;
      height: 180px;
      border-radius: 10px;
      overflow: hidden;
      border: 1px solid @border-color;
      background: #f8fafc;

      .img-content {
        width: 100%;
        height: 100%;
        display: block;
      }

      .hover-mask {
        position: absolute;
        inset: 0;
        background: rgba(15, 23, 42, 0.55);
        backdrop-filter: blur(2px);
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        transition: opacity 0.25s ease;

        .del-btn {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: #ffffff;
          color: @danger-color;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
          transition: transform 0.2s;

          &:hover {
            transform: scale(1.12);
          }
        }
      }

      &:hover .hover-mask {
        opacity: 1;
      }
    }

    .upload-trigger {
      width: 100%;
      height: 130px;
      border: 1.5px dashed #cbd5e1;
      border-radius: 10px;
      background: #f8fafc;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 6px;
      transition: all 0.25s ease;

      .icon {
        font-size: 20px;
        color: @text-sub;
      }

      .text {
        font-size: 13.5px;
        font-weight: 600;
        color: @text-main;
      }

      .sub-text {
        font-size: 11.5px;
        color: @text-muted;
      }

      &:hover {
        border-color: @primary-color;
        background: @primary-light;

        .icon,
        .text {
          color: @primary-color;
        }
      }
    }
  }

  .action-bar {
    margin-top: 32px;
    border-top: 1px solid @border-color;
    padding-top: 20px;

    .save-btn {
      width: 100%;
      height: 42px;
      border-radius: 8px;
      background-color: @primary-color;
      border-color: @primary-color;
      font-weight: 600;
      box-shadow: 0 4px 12px rgba(93, 95, 239, 0.25);
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background-color: @primary-hover;
        border-color: @primary-hover;
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(93, 95, 239, 0.35);
      }
    }
  }
}

// 右侧真机拟物视口
.preview-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;

  .preview-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: @text-sub;
    margin-bottom: 14px;

    .badge-dot {
      width: 8px;
      height: 8px;
      background: #10b981;
      border-radius: 50%;
      box-shadow: 0 0 6px rgba(16, 185, 129, 0.6);
    }
  }

  .mockup-phone {
    width: 290px;
    height: 540px;
    background: #ffffff;
    border-radius: 36px;
    border: 10px solid #0f172a;
    box-shadow: 0 16px 36px -6px rgba(15, 23, 42, 0.16);
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .phone-top-bar {
      width: 100%;
      height: 20px;
      display: flex;
      justify-content: center;
      background: #ffffff;
      z-index: 10;

      .notch {
        width: 76px;
        height: 12px;
        background: #0f172a;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }

    .phone-screen {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #f8fafc;
    }

    .mock-nav {
      height: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 14px;
      border-bottom: 1px solid @border-color;
      background: #ffffff;
      font-size: 13px;
      color: @text-main;

      .nav-title {
        font-weight: 700;
      }
    }

    .screen-hero {
      width: 100%;
      height: 170px;
      background: #e2e8f0;
      overflow: hidden;
      flex-shrink: 0;

      .hero-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .hero-placeholder {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;
        color: @text-muted;
        font-size: 11px;

        .el-icon {
          font-size: 24px;
        }
      }
    }

    .screen-body {
      flex: 1;
      padding: 14px 16px;
      overflow-y: auto;
      display: flex;
      flex-direction: column;

      .screen-title {
        font-size: 15px;
        font-weight: 700;
        color: @text-main;
        margin: 0 0 8px 0;
        line-height: 1.4;
      }

      .screen-desc {
        font-size: 12.5px;
        color: @text-sub;
        line-height: 1.65;
        white-space: pre-wrap;
        word-break: break-all;
      }
    }

    .screen-footer {
      padding: 10px 16px 14px;
      background: #ffffff;
      border-top: 1px solid @border-color;

      .mock-next-btn {
        width: 100%;
        height: 36px;
        border-radius: 18px;
        border: none;
        background: @primary-color;
        color: #ffffff;
        font-size: 12px;
        font-weight: 600;
        cursor: default;
        box-shadow: 0 3px 8px rgba(93, 95, 239, 0.3);
      }
    }
  }
}
</style>
